const auth = {
	title: "Auth",
	sign_in: "Sign In to Admin",
	login_error: "Incorrect login. Please try again.",
	login: "Login",
	logout: "Logout",
	email: "Email",
	mobile: "Mobile",
	password: "Password",
	change_password: "Change Password",
	update_password: "Update Password",
	current_password: "Current Password",
	update_password_error: "Failed to update password. Please try again.",
	password_does_not_match_error: "Password does not match.",
	new_password: "New Password",
	new_password_retype: "Retype New Password",
	remember: "Remember me",
	sign_up: "Sign Up",
	no_account: "Don't have an account?",
	success: "Success",
	error: "Error",
	login_email: "Login via Email",
	login_mobile: "Login via Mobile",
	sms_code: "SMS Code",
	enter_code: "Enter Code",
	enter_code_sms: "Confirmation code is sent to {mobile}",
	sms_otp_send_failed: "SMS not sent. Please contact administrator.",
	sms_otp_incorrect_code: "Incorrect or expired code.",
	forgot: {
		back: "Back",
		send_request: "Send Password Request",
		forgot_t: "Forgot Password",
		confirm_pass: "Confirm Password",
		forgot: "Forgot password?",
		invalidrequest_t: "Invalid Request",
		invalidrequest_m: "The requested link is invalid.",
		reset_t: "Password Reset",
		reset_pass: "Reset Password",
		reset_success_m: "Password reset success",
		reset_error_m: "Cannot reset password at the moment. Please try again in a few minutes.",
		forgot_success_m: "A password reset link has been sent.",
		forgot_error_m: "Cannot send at the moment. Please try again later.",
		unregistered: " is not registered.",
		invalid_token: "Invalid password reset token.",
		invalid_email: "Invalid Email address.",
		valid_token: "A new password is sent to your email address ({email})",
		expired_token: "Password link is expired.",
	},
};
export default auth;